import authenticatorSlice from "./authenticator/authenticator-slice";
import bookingsSlice from "../pages/Bookings/bookingsSlice";
//import customerDetailsSlice from "../pages/Customers/components/CustomerDetail/components/Booking/customerDetailsSlice";
import partnerSlice from "../pages/Partners/partnerSlice";
import customerDetailsSlice from "../pages/Customers/components/CustomerDetail/components/Booking/customerDetailsSlice";
import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

const rootReducer = combineReducers({
    // counter: counterSlice,
    authorizer: authenticatorSlice,
    bookings: bookingsSlice,
    //customerDetails: customerDetailsSlice,
    partnerList: partnerSlice,
    customerDetails: customerDetailsSlice,
});
 
const store = configureStore({
    reducer: rootReducer,
});

// Define RootState based on the store's getState to avoid type export issues
export type RootState = ReturnType<typeof store.getState>;

export const useAppDispatch: () => typeof store.dispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;